export default __webpack_public_path__ + "static/media/team83.2d58f97e.JPG";